import { render, staticRenderFns } from "./Viewper.vue?vue&type=template&id=c72c73f2&scoped=true"
import script from "./Viewper.vue?vue&type=script&lang=js"
export * from "./Viewper.vue?vue&type=script&lang=js"
import style0 from "./Viewper.vue?vue&type=style&index=0&id=c72c73f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72c73f2",
  null
  
)

export default component.exports